import inventory from "@/assets/generated/media-inventory.json";
import delivery from "@/assets/generated/media-delivery.json";
import { deliveredMediaUrl } from "./media-origin";

export interface MediaAsset {
    bytes: number;
    sha256: string;
    contentType: string;
    key: string;
    width?: number;
    height?: number;
    duration?: number;
}

export function mediaUrl(src: string): string {
    if (!delivery.enabled || process.env.NEXT_PUBLIC_MEDIA_DELIVERY === "local") return src;
    const url = (delivery.urls as Record<string, string>)[src];
    return url ? deliveredMediaUrl(url) : src;
}

export function mediaAsset(src: string): MediaAsset | undefined {
    return (inventory.assets as Record<string, MediaAsset>)[src];
}

export function absoluteMediaUrl(src: string, siteUrl: string): string {
    return new URL(mediaUrl(src), siteUrl).href;
}

export function videoSources(src: string): { src: string; type: string }[] {
    const pathname = src.split(/[?#]/)[0];
    if (/\.(mp4|webm)$/i.test(pathname)) {
        return [{ src: mediaUrl(src), type: pathname.endsWith(".webm") ? "video/webm" : "video/mp4" }];
    }
    return [
        { src: mediaUrl(`${src}.webm`), type: "video/webm" },
        { src: mediaUrl(`${src}.mp4`), type: "video/mp4" },
    ];
}

export function videoPoster(src: string): string | undefined {
    const base = src.split(/[?#]/)[0].replace(/\.(mp4|webm)$/i, "");
    const poster = `${base}.poster.webp`;
    return mediaAsset(poster) ? mediaUrl(poster) : undefined;
}
